import { ck } from "fire-wind-water";

class GrundfosVideoSocket {
  socketUrl = "https://grundfos-api.smarket.net.cn/";

  init(id: string) {
    const tenantId = parseInt(id, 10);
    if (tenantId !== 100360 && tenantId !== 1038 && tenantId !== 100404) {
      return;
    }
    if (100404 == tenantId) {
      // ind专用地址
      this.socketUrl = "https://spi.wechat.grundfos.cn/";
    }
    import("socket.io-client").then((res) => {
      console.log(res);
      this.join(res.default);
    });
  }

  join(io: any) {
    try {
      const smkSockets = [];
      document.addEventListener(
        "play",
        (e: any) => {
          const videoObj: HTMLVideoElement = e.target;
          if (videoObj.nodeName === "VIDEO") {
            const videoUrl = videoObj.currentSrc;
            const videoDuration = videoObj.duration;
            const playStartTime = videoObj.currentTime;
            const referrer = encodeURIComponent(window.location.href);
            const cookieId = ck.cookie("globalUserId");

            smkSockets[videoUrl] = smkSockets[videoUrl] = io(
              this.socketUrl +
                "/?cookieId=" +
                cookieId +
                "&videoUrl=" +
                encodeURIComponent(videoUrl) +
                "&videoDuration=" +
                videoDuration +
                "&playStartTime=" +
                playStartTime +
                "&referrer=" +
                referrer,
              { path: "/socket/socket.io" }
            );
            smkSockets[videoUrl].on("connect", () => {
              console.log("当前socketId：" + smkSockets[videoUrl].id);
            });
          }
        },
        true
      );
      document.addEventListener(
        "pause",
        (e: any) => {
          const videoObj: HTMLVideoElement = e.target;
          if (videoObj.nodeName === "VIDEO") {
            smkSockets[videoObj.currentSrc].disconnect();
          }
        },
        true
      );
    } catch (e) {
      console.log(e);
    }
  }
}

export const $GrundfosVideoSocket = new GrundfosVideoSocket();
